import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../components/Layout.js'
import { Button } from '../components/Button.js'
import { Icon } from '../assets/icons/index.js'
import { colors } from '../utils/colors.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { useEffect } from 'react'

export const InfradownPage = () => {
  const track = useTrack('infradown')
  const { infraDownTitle, infraDownDescription, refreshButton } =
    useDictionary()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <h1 className="bn">{infraDownTitle}</h1>
      <p className="bi bm">
        {infraDownDescription}
      </p>
      <Button
        leadIcon={<Icon type="reloadIcon" color={colors.black} />}
        onClick={() => window.location.reload()}
      >
        {refreshButton}
      </Button>
    </Layout>
  )
}
